/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";

import session from "./session";

export default class {
  static getAll = async (keyword, tags) => {
    let result = {
      data: null,
      error: null,
    };

    const data = {
      keyword: keyword,
      userId: session.get("user")._id,
      tags: tags || [],
    };

    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/all`, data)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static getSharedWithMe = async (keyword) => {
    let result = {
      data: null,
      error: null,
    };

    const data = {
      keyword: keyword,
      userId: session.get("user")._id,
      email: session.get("user").email,
    };

    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/sharedwithme`, data)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static getByUserId = async (userId) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/all`, { userId: userId })
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static add = async (obj) => {
    let result = {
      data: null,
      error: null,
    };

    const fd = new FormData();
    for (const [key, value] of Object.entries(obj)) {
      fd.append(key, value);
    }

    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects`, fd)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static update = async (id, obj) => {
    let result = {
      data: null,
      error: null,
    };

    const fd = new FormData();
    for (const [key, value] of Object.entries(obj)) {
      fd.append(key, value);
    }

    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/${id}`, fd)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static updateThumbnail = async (projectId, file) => {
    let result = { data: null, error: null };
    const fd = new FormData();
    fd.append("file", file);
    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/update-thumbnail/${projectId}`, fd)
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response.data;
      });
    return result;
  };

  static uploadProjectLogo = async (projectId, file) => {
    let result = { data: null, error: null };
    const fd = new FormData();
    fd.append("file", file);
    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/update-logo/${projectId}`, fd)
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data || "Upload failed";
      });
    return result;
  };

  static removeProjectLogo = async (projectId) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/remove-logo/${projectId}`)
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data || "Remove failed";
      });
    return result;
  };

  static updateThumbnailFromUrl = async (projectId, url) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/update-thumbnail-url/${projectId}`, { url })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response.data;
      });
    return result;
  };

  static getDiscover = async (keyword) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/discover`, { keyword: keyword || "" })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data;
      });
    return result;
  };

  static setVisibility = async (projectId, isPublic) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/visibility/${projectId}`, { isPublic })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response.data;
      });
    return result;
  };

  static lockView = async (projectId, lockedView) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/lock-view/${projectId}`, { lockedView })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response.data;
      });
    return result;
  };

  static get = async (id, isInnerView, viewPortWidth) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/projects/${id}?isInnerView=${isInnerView}&viewPortWidth=${viewPortWidth}`
      )
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static incrementViews = async (id) => {
    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/view/${id}`)
      .catch(() => {});
  };

  static delete = async (id) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .delete(`${process.env.REACT_APP_API_URL}/projects/${id}`)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static addTags = async (id, tag) => {
    let result = {
      data: null,
      error: null,
    };

    const payload = {
      projectId: id,
      tag: tag,
    };

    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/add-tags`, payload)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static getAllTags = async () => {
    let result = {
      data: null,
      error: null,
    };
    await axios
      .get(`${process.env.REACT_APP_API_URL}/tags/${session.get("user")._id}`)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };
  static editTag = async (id, data) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .put(`${process.env.REACT_APP_API_URL}/tags/${id}`, data)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        //result.error = err.response.data;
        result.error = "Not able to update Tag";
      });

    return result;
  };

  static deleteTag = async (id) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .delete(`${process.env.REACT_APP_API_URL}/tags/${id}`)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static duplicate = async (id) => {
    let result = {
      data: null,
      error: null,
    };

    const payload = {
      projectId: id,
    };

    await axios
      .post(`${process.env.REACT_APP_API_URL}/projects/duplicate`, payload)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static deleteLogo = async (id) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .delete(`${process.env.REACT_APP_API_URL}/projects/logo/${id}`)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static updateTitle = async (id, title) => {
    let result = {
      data: null,
      error: null,
    };

    const data = {
      title: title,
    };

    await axios
      .post(
        `${process.env.REACT_APP_API_URL}/projects/update-title/${id}`,
        data
      )
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        //result.error = err.response.data;
        result.error = "Not able to update Title";
      });

    return result;
  };
}
